var l={holyContainer:"layout-with-alert-styles-module_holyContainer__XUl8T"};export{l as default};
//# sourceMappingURL=layout-with-alert.styles.module.scss.js.map
